import { GroupItem } from './GroupItem';
import { StateFlagItem } from './StateFlagItem';
import { StateTaskItem } from './StateTaskItem';
import { StateItem } from './StateViewController';

export const Item = ({ item, columnIndex }: { item: StateItem; columnIndex?: number }) => {
  const selectItem = () => {
    const itemType = item.items ? 'group' : item.stateViewPaused || item.stateViewFailed ? 'task' : 'flag';

    switch (itemType) {
      case 'group':
        return <GroupItem item={item} columnIndex={columnIndex} />;
      case 'flag':
        return <StateFlagItem stateView={item.stateView!} columnIndex={columnIndex} />;
      case 'task':
        return (
          <StateTaskItem
            stateView={item.stateView!}
            stateViewPaused={item.stateViewPaused!}
            stateViewFailed={item.stateViewFailed!}
            columnIndex={columnIndex}
          />
        );
    }
  };

  return <>{selectItem()}</>;
};
